
module.exports = {
	ACCESS_TOKEN_HEADER_NAME: 'openstack-xavisoft-access-token',
	REFRESH_TOKEN_HEADER_NAME: 'openstack-xavisoft-refresh-token',
	LOCAL_STORAGE_KEY: 'openstack-xavisoft-auth',
}